import EventEmitter from 'eventemitter3';

/**
 * EventEmitter used to communicate Luminary related actions from one component
 * to another. This should be used over prop drilling and/or redux for components
 * to encapsulate their own luminary related logic while allowing other components
 * to "trigger" that behaviour.
 */
export enum SLIDE_EVENTS {
    START_PREVIEW_PLAYBACK = 'START_PREVIEW_PLAYBACK',
    START_SCENE_PREVIEW_PLAYBACK = 'START_SCENE_PREVIEW_PLAYBACK',
    GLOBAL_STOP_PREVIEW_PLAYBACK = 'GLOBAL_STOP_PREVIEW_PLAYBACK',
    START_EDITING_TEXT = 'START_EDITING_TEXT',
    STOP_EDITING_TEXT = 'STOP_EDITING_TEXT',
    GLOBAL_STOP_EDITING = 'GLOBAL_STOP_EDITING',
    START_EDITING_NON_TEXT_ASSET = 'START_EDITING_NON_TEXT_ASSET',
    FONT_LOAD_FAILURE = 'FONT_LOAD_FAILURE',
    FONT_LOAD_START = 'FONT_LOAD_START',
    UPDATE_PREVIEW_AT_TIME = 'UPDATE_PREVIEW_AT_TIME',
    TEXT_ASSET_SELECTED = 'TEXT_ASSET_SELECTED',
}

export type StartScenePreviewPlaybackPayload = {
    sceneId: string;
    sceneGroupId: string;
};

export type TextAssetPayload = {
    sceneGroupId: string;
    sceneId: string;
    subsceneIndex: number;
    assetId: string;
    assetType: string;
    rootAssetGroupId?: string | null;
    clickCoordinates?: { x: number; y: number };
};

export type StopEditingTextPayload = {
    sceneId: string;
    subsceneIndex: number;
};

export type StartEditingNonTextAssetPayload = {
    sceneGroupId: string;
    sceneId: string;
    subsceneIndex: number;
    assetId: string;
    assetType: string;
};

const SlideEventEmitter = new EventEmitter();
export default SlideEventEmitter;
